"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const tools_1 = require("../tools");
const createPokerSession_graphql_1 = tslib_1.__importDefault(require("../gql/poker-sessions/mutations/createPokerSession.graphql"));
const updatePokerSession_graphql_1 = tslib_1.__importDefault(require("../gql/poker-sessions/mutations/updatePokerSession.graphql"));
const deletePokerSession_graphql_1 = tslib_1.__importDefault(require("../gql/poker-sessions/mutations/deletePokerSession.graphql"));
const createPokerSessionInvites_graphql_1 = tslib_1.__importDefault(require("../gql/poker-sessions/mutations/createPokerSessionInvites.graphql"));
const deletePokerSessionMember_graphql_1 = tslib_1.__importDefault(require("../gql/poker-sessions/mutations/deletePokerSessionMember.graphql"));
const acceptPokerSessionInvite_graphql_1 = tslib_1.__importDefault(require("../gql/poker-sessions/mutations/acceptPokerSessionInvite.graphql"));
const declinePokerSessionInvite_graphql_1 = tslib_1.__importDefault(require("../gql/poker-sessions/mutations/declinePokerSessionInvite.graphql"));
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
class PokerSession extends BaseModel_1.default {
    constructor() {
        super(...arguments);
        this.createMutation = createPokerSession_graphql_1.default;
        this.updateMutation = updatePokerSession_graphql_1.default;
    }
    defaults() {
        return {
            name: 'New Session',
            uuid: '',
            description: '',
            users: [],
            tasks: [],
            activeTask: {},
            organization: {
                uuid: tools_1.getStore().getters.organization.uuid,
            },
            options: {
                pointsLimit: {
                    show: false,
                    points: 0,
                },
                allowRevote: false,
                showScore: false,
                timer: 0,
            },
        };
    }
    delete() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(deletePokerSession_graphql_1.default, {
                uuid: this.uuid,
            }));
        });
    }
    inviteUsers(users) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(createPokerSessionInvites_graphql_1.default, {
                pokerSessionUuid: this.uuid,
                users: yield Promise.all(users.map((u) => tslib_1.__awaiter(this, void 0, void 0, function* () { return u.getUpdateVariables(); }))),
            }));
        });
    }
    deleteMember(member) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(deletePokerSessionMember_graphql_1.default, {
                pokerSessionUuid: this.uuid,
                userUuid: member.uuid,
            }));
        });
    }
    acceptInvite(inviteUuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(acceptPokerSessionInvite_graphql_1.default, {
                uuid: inviteUuid,
            }));
        });
    }
    declineInvite(inviteUuid) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(declinePokerSessionInvite_graphql_1.default, {
                uuid: inviteUuid,
            }));
        });
    }
}
exports.default = PokerSession;
//# sourceMappingURL=PokerSession.js.map